export default __webpack_public_path__ + "static/media/3d807ec8.svg";